import { HttpClient } from '../../httpClient'

export const downloadGemFile = async (gemFileId: string): Promise<Blob> => {
  const url = new URL(
    `/opal_ai/v3/gem_files/${gemFileId}/download`,
    window.location.origin
  )

  return HttpClient()
    .get(url.toString(), { responseType: 'blob' })
    .then((res) => res.data)
}
